/** Pure key helpers for the GA day-cache (safe to unit-test without a browser). */

function sameLocalDay(ts, now = Date.now()) {
  if (!ts) return false;
  const a = new Date(ts);
  const b = new Date(now);
  return a.getFullYear() === b.getFullYear()
    && a.getMonth() === b.getMonth()
    && a.getDate() === b.getDate();
}

function gaPersistUrl(kind, dashboardId, page, version) {
  const v = encodeURIComponent(version || '1');
  if (kind === 'page') {
    return `https://ga-cache.lgl/page/${dashboardId}/${Math.max(1, parseInt(page, 10) || 1)}?v=${v}`;
  }
  return `https://ga-cache.lgl/${kind}/${dashboardId}?v=${v}`;
}

module.exports = { sameLocalDay, gaPersistUrl };
